import React from "react";
import { Link } from "react-router-dom";

import Loader from "../../../../../core/common/loader";
import LeadTransferExportModal from "../../components/lead-transfer/LeadTransferExportModal";
import LeadsTransferHeader from "../components/LeadsTransferHeader";
import LeadTransferHistoryTable from "../components/LeadTransferHistoryTable";
import TransferLeadsModal from "../components/modals/TransferLeadsModal";
import useLeadsTransfer from "../hooks/useLeadsTransfer";
import "../components/leadsTransfer.css";

const LeadsTransferPage: React.FC = () => {
  const t = useLeadsTransfer();

  return (
    <>
      {t.isLoading && <Loader />}
      <div className="page-wrapper">
        <div className="content">
          <LeadsTransferHeader
            {...t.header}
            onTransferClick={t.openTransferModal}
            onExportClick={t.openExportModal}
          />

          <div className="card">
            <div className="card-body bg-white d-flex align-items-center justify-content-between flex-wrap row-gap-2 rounded-3">
              <h5 className="mb-0 d-flex align-items-center">
                <i className="ti ti-history text-info me-2" style={{ fontSize: 18 }} />
                Lead Transfer History
              </h5>
              {t.formName ? (
                <span className="text-muted" style={{ fontSize: 13 }}>
                  Form: {t.formName}
                </span>
              ) : null}
            </div>

          </div>
          <div className="card rounded-3 bg-white">
            <LeadTransferHistoryTable rows={t.transferHistory} loading={t.isLoading} />
          </div>
        </div>

        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2025 © CMS.</p>
          <p>
            Designed &amp; Developed By{" "}
            <Link to="#" onClick={(e: any) => e.preventDefault()} className="text-primary">
              ZYVO
            </Link>
          </p>
        </div>
      </div>

      <TransferLeadsModal {...t.transferModal} />

      <LeadTransferExportModal {...t.exportModal} />
    </>
  );
};

export default LeadsTransferPage;
